<template>
  <div :class="['tip_wrap', $style.text_wrap]">
    <tip-icon iconName="key" />
    <div :class="$style.right_wrap">
      <p>当您的账号被盗或存在安全隐患时，</p>
      <p>可以通过锁定账号减免损失。</p>
      <!-- 魔侠锁定解锁提示 -->
      <p v-if="gameId != 5">
        <span v-if="isLock == 0"
          >锁定账号后将不能登录《{{ this.gameName }}》</span
        >
        <template v-else>
          <span>您的账号{{ this.phone }}已锁定，</span>
          <span>暂不能登录《{{ this.gameName }}》</span>
        </template>
      </p>
      <!-- 巫神锁定解锁提示 -->
      <p v-else>
        <span>锁定成功后将不能登录已锁定的服务器</span>
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import tipIcon from "../../../components/TipIcon";
export default {
  name: "lockStatus",
  props: {
    isLock: String,
    phone: String
  },
  components: {
    tipIcon
  },
  computed: {
    ...mapGetters(["gameName", "gameId"])
  }
};
</script>
<style lang="less" module>
.text_wrap {
  margin-bottom: 0.77rem;
  margin-top: 0.5rem;
  .right_wrap {
    width: 4.8rem;
  }
}
</style>
